module.exports = __webpack_public_path__ + "static/media/test.552538b2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/shared/test.mp4
// module id = 65
// module chunks = 0